"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationNodesIO = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyUtils_1 = require("./SankeyUtils");
const SankeyDrawLayout_1 = require("../draw/SankeyDrawLayout");
const fa_1 = require("react-icons/fa");
const SankeyDrawFunction_1 = require("../draw/SankeyDrawFunction");
const react_2 = require("@chakra-ui/react");
// Search links coming from/going to(io) from a face of it (pos) and return them
const getIOLink = (data, display_nodes, multi_selected_nodes, pos, io, GetLinkValue) => {
    const n = multi_selected_nodes.current[0];
    let link_io = [];
    if (io == 'input') {
        if (pos == 'left') {
            //Recherche tous les flux entrant a gauche
            link_io = Object.values(n.inputLinksId).filter(k => {
                const recy = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'recycling');
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_s = data.nodes[data.links[k].idSource];
                const cond_no_recy = (((n_s.x <= n.x && n_s.position != 'relative') || (n_s.position == 'relative' && n_s.x < 0)) && !recy);
                const cond_recy = (recy && n_s.x >= n.x);
                return (cond_no_recy || cond_recy) && (ori == 'hh' || ori == 'vh') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
        else if (pos == 'right') {
            //Recherche tous les flux entrant a droite
            link_io = Object.values(n.inputLinksId).filter(k => {
                const recy = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'recycling');
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_s = data.nodes[data.links[k].idSource];
                const cond_no_recy = (((n_s.x >= n.x && n_s.position != 'relative') || (n_s.position == 'relative' && n_s.x > 0)) && !recy);
                const cond_recy = (recy && n_s.x < n.x);
                return (cond_no_recy || cond_recy) && (ori == 'hh' || ori == 'vh') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
        else if (pos == 'top') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.inputLinksId).filter(k => {
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_s = data.nodes[data.links[k].idSource];
                return n_s.y < n.y && (ori == 'vv' || ori == 'hv') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.inputLinksId).filter(k => {
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_s = data.nodes[data.links[k].idSource];
                return n_s.y >= n.y && (ori == 'vv' || ori == 'hv') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
    }
    else if (io == 'output') {
        if (pos == 'left') {
            //Recherche tous les flux entrant a gauche
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const recy = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'recycling');
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_t = data.nodes[data.links[k].idTarget];
                const cond_no_recy = (((n_t.x < n.x && n_t.position != 'relative') || (n_t.position == 'relative' && n_t.x <= 0)) && !recy);
                const cond_recy = (recy && n_t.x > n.x);
                return ((cond_no_recy || cond_recy)) && (ori == 'hh' || ori == 'hv') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
        else if (pos == 'right') {
            //Recherche tous les flux entrant a droite
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const recy = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'recycling');
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_t = data.nodes[data.links[k].idTarget];
                const cond_no_recy = (((n_t.x >= n.x && n_t.position != 'relative') || (n_t.position == 'relative' && n_t.x > 0)) && !recy);
                const cond_recy = (recy && n_t.x <= n.x);
                return (cond_no_recy || cond_recy) && (ori == 'hh' || ori == 'hv') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
        else if (pos == 'top') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_t = data.nodes[data.links[k].idTarget];
                return n_t.y < n.y && (ori == 'vv' || ori == 'vh') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
        else if (pos == 'bottom') {
            //Recherche tous les flux entrant en haut
            link_io = Object.values(n.outputLinksId).filter(k => {
                if (!data.links[k]) {
                    return false;
                }
                const ori = (0, SankeyUtils_1.ReturnValueLink)(data, data.links[k], 'orientation');
                const n_t = data.nodes[data.links[k].idTarget];
                return n_t.y >= n.y && (ori == 'vv' || ori == 'vh') && (0, SankeyUtils_1.LinkVisible)(data.links[k], data, display_nodes, GetLinkValue);
            });
        }
    }
    return link_io;
};
/**
   * Switch the link with the one on top of him (similar to drag link)
   *
   * @param {string} k_link
   * @param {string} pos
   * @param {string} io
   */
const handleUpLinkIOPos = (data, display_nodes, multi_selected_nodes, k_link, pos, io, GetLinkValue, link_function, setForceUpdate, forceUpdate) => {
    const n = multi_selected_nodes.current[0];
    const link_io = getIOLink(data, display_nodes, multi_selected_nodes, pos, io, GetLinkValue);
    if (io == 'input') {
        if (pos == 'left') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    else if (io == 'output') {
        if (pos == 'left') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) > 0) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) - 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    link_function.RedrawLinks(link_io.map(lid => data.links[lid]));
    setForceUpdate(!forceUpdate);
};
/**
   * Switch the link with the one below him (similar to drag link)
   *
   * @param {string} k_link
   * @param {string} pos
   * @param {string} io
   */
const handleDownLinkIOPos = (data, display_nodes, multi_selected_nodes, k_link, pos, io, GetLinkValue, link_function, setForceUpdate, forceUpdate) => {
    const n = multi_selected_nodes.current[0];
    const link_io = getIOLink(data, display_nodes, multi_selected_nodes, pos, io, GetLinkValue);
    if (io == 'input') {
        if (pos == 'left') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Repositionne le flux avant le flux entrant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.inputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.inputLinksId.indexOf(k_link);
                n.inputLinksId.splice(posElemt, 1);
                n.inputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    else if (io == 'output') {
        if (pos == 'left') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'right') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'top') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
        else if (pos == 'bottom') {
            //Repositionne le flux avant le flux sortant du même coté
            if (link_io.includes(k_link) && link_io.indexOf(k_link) < link_io.length - 1) {
                const ElementPrecInFilter = link_io[link_io.indexOf(k_link) + 1];
                const posElementPrec = n.outputLinksId.indexOf(ElementPrecInFilter);
                const posElemt = n.outputLinksId.indexOf(k_link);
                n.outputLinksId.splice(posElemt, 1);
                n.outputLinksId.splice(posElementPrec, 0, k_link);
            }
        }
    }
    link_function.RedrawLinks(link_io.map(lid => data.links[lid]));
    setForceUpdate(!forceUpdate);
};
/**
   * Check if the selected node has links coming from/going to(io) from a face of it (pos)
   *
   * @param {string} io
   * @param {string} pos
   * @returns {boolean}
   */
const has_link_come_from = (data, display_nodes, multi_selected_nodes, io, pos, GetLinkValue) => {
    const link_io = getIOLink(data, display_nodes, multi_selected_nodes, pos, io, GetLinkValue);
    return link_io.length == 0;
};
/**
   * Create a html table displaying links attached to the selected node and filtered by where they're coming/going from
   *
   * @param {string} pos
   * @param {string} io
   * @returns {*}
   */
const tab_pos_link = (t, data, display_nodes, multi_selected_nodes, pos, io, tab_colored, GetLinkValue, link_function, setForceUpdate, forceUpdate) => {
    const link_io = getIOLink(data, display_nodes, multi_selected_nodes, pos, io, GetLinkValue);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, className: 'node_group_tags_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, t('Menu.flux')),
                    react_1.default.createElement("th", null, t('Tags.Position')))),
            react_1.default.createElement("tbody", null, link_io.map((k, i) => {
                const color = (0, SankeyUtils_1.LinkColor)(data.links[k], data, GetLinkValue);
                const bc = { 'backgroundColor': (color && tab_colored) ? color : 'inherit' };
                const n_s = data.nodes[data.links[k].idSource];
                const n_t = data.nodes[data.links[k].idTarget];
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: bc }, n_s.name + '===>' + n_t.name),
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "button_position", size: "sm" },
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleUpLinkIOPos(data, display_nodes, multi_selected_nodes, k, pos, io, GetLinkValue, link_function, setForceUpdate, forceUpdate) },
                                react_1.default.createElement(fa_1.FaArrowAltCircleUp, null)),
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleDownLinkIOPos(data, display_nodes, multi_selected_nodes, k, pos, io, GetLinkValue, link_function, setForceUpdate, forceUpdate) },
                                react_1.default.createElement(fa_1.FaArrowAltCircleDown, null))))));
            })))));
};
const SankeyMenuConfigurationNodesIO = (applicationContext, dict_variable_application_data, dict_variable_elements_selected, GetLinkValue, node_function, link_function, ComponentUpdater, menu_for_modal = false) => {
    const { t } = applicationContext;
    const { data, display_nodes, display_links } = dict_variable_application_data;
    const { multi_selected_nodes, multi_selected_links } = dict_variable_elements_selected;
    const { updateComponentMenuNodeIOSelectSideNode } = ComponentUpdater;
    const [link_io, set_link_io] = (0, react_1.useState)('output');
    const [link_pos, set_link_pos] = (0, react_1.useState)('right');
    const [tab_colored, set_tab_colored] = (0, react_1.useState)(false);
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    const updateDefaultNodeIO = () => {
        if (multi_selected_nodes.current.length === 1) {
            const k_display_link = Object.values(display_links).map(l => l.idLink);
            if (multi_selected_nodes.current[0].inputLinksId.filter(lid => k_display_link.includes(lid)).length > multi_selected_nodes.current[0].outputLinksId.filter(lid => k_display_link.includes(lid)).length) {
                const obj_list_link = {
                    left: getIOLink(data, display_nodes, multi_selected_nodes, 'left', 'input', GetLinkValue).length,
                    right: getIOLink(data, display_nodes, multi_selected_nodes, 'right', 'input', GetLinkValue).length,
                    top: getIOLink(data, display_nodes, multi_selected_nodes, 'top', 'input', GetLinkValue).length,
                    bottom: getIOLink(data, display_nodes, multi_selected_nodes, 'bottom', 'input', GetLinkValue).length,
                };
                const side_with_most_link = Object.entries(obj_list_link)
                    .sort(([, a], [, b]) => b - a)[0][0];
                if (link_io !== 'input') {
                    set_link_io('input');
                }
                if (link_pos !== side_with_most_link) {
                    set_link_pos(side_with_most_link);
                }
            }
            else {
                const obj_list_link = {
                    left: getIOLink(data, display_nodes, multi_selected_nodes, 'left', 'output', GetLinkValue).length,
                    right: getIOLink(data, display_nodes, multi_selected_nodes, 'right', 'output', GetLinkValue).length,
                    top: getIOLink(data, display_nodes, multi_selected_nodes, 'top', 'output', GetLinkValue).length,
                    bottom: getIOLink(data, display_nodes, multi_selected_nodes, 'bottom', 'output', GetLinkValue).length,
                };
                const side_with_most_link = Object.entries(obj_list_link)
                    .sort(([, a], [, b]) => b - a)[0][0];
                if (link_io !== 'output') {
                    set_link_io('output');
                }
                if (link_pos !== side_with_most_link) {
                    set_link_pos(side_with_most_link);
                }
            }
        }
    };
    updateComponentMenuNodeIOSelectSideNode.current.push(updateDefaultNodeIO);
    const logo_enter = react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 512 512", width: "15", height: "15" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M170.699,448H72.757c-4.814-0.012-8.714-3.911-8.725-8.725V72.725c0.012-4.814,3.911-8.714,8.725-8.725h97.941   c17.673,0,32-14.327,32-32s-14.327-32-32-32H72.757C32.612,0.047,0.079,32.58,0.032,72.725v366.549   C0.079,479.42,32.612,511.953,72.757,512h97.941c17.673,0,32-14.327,32-32S188.372,448,170.699,448z" }),
            react_1.default.createElement("path", { d: "M480.032,224l-290.987,0.576l73.941-73.941c12.501-12.495,12.506-32.758,0.011-45.259s-32.758-12.506-45.259-0.011   l-82.752,82.752c-37.491,37.49-37.491,98.274-0.001,135.764c0,0,0.001,0.001,0.001,0.001l82.752,82.752   c12.501,12.495,32.764,12.49,45.259-0.011s12.49-32.764-0.011-45.259l-72.811-72.789L480.032,288   c17.673-0.035,31.971-14.391,31.936-32.064S497.577,223.965,479.904,224H480.032z" })));
    const logo_exit = react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", width: "15", height: "15" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M170.698,448H72.757c-4.814-0.012-8.714-3.911-8.725-8.725V72.725c0.012-4.814,3.911-8.714,8.725-8.725h97.941   c17.673,0,32-14.327,32-32s-14.327-32-32-32H72.757C32.611,0.047,0.079,32.58,0.032,72.725v366.549   C0.079,479.42,32.611,511.953,72.757,512h97.941c17.673,0,32-14.327,32-32S188.371,448,170.698,448z" }),
            react_1.default.createElement("path", { d: "M483.914,188.117l-82.816-82.752c-12.501-12.495-32.764-12.49-45.259,0.011s-12.49,32.764,0.011,45.259l72.789,72.768   L138.698,224c-17.673,0-32,14.327-32,32s14.327,32,32,32l0,0l291.115-0.533l-73.963,73.963   c-12.042,12.936-11.317,33.184,1.618,45.226c12.295,11.445,31.346,11.436,43.63-0.021l82.752-82.752   c37.491-37.49,37.491-98.274,0.001-135.764c0,0-0.001-0.001-0.001-0.001L483.914,188.117z" })));
    const content_reorg = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { style: { fontSize: '14px', fontWeight: 'bold', textDecoration: 'underline' } }, t('Noeud.Reorg_title')),
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.7' },
                t('Noeud.tooltips.Reorg'),
                " ") },
            react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '100%' }, variant: 'primary', onClick: () => {
                    Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                        (0, SankeyDrawLayout_1.reorganize_node_inputLinksId)(data, d, data.nodes, data.links);
                        (0, SankeyDrawLayout_1.reorganize_node_outputLinksId)(data, d, data.nodes, data.links);
                    });
                    node_function.RedrawNodes(Object.values(dict_variable_application_data.display_nodes));
                    link_function.RedrawLinks(Object.values(dict_variable_application_data.display_links));
                    setForceUpdate(!forceUpdate);
                } }, t('Noeud.Reorg'))));
    // Content to reorganize the i/o of only 1 node at the time
    const content_for_one_node = multi_selected_nodes.current.length === 1 ? react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Row, { className: 'input_row' },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('Noeud.PF.FES'))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.ButtonGroup, { style: { width: '100%' } },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.2' },
                            t('Noeud.PF.tooltips.ent'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: (link_io == 'input') ? 'primary' : 'outline-primary', onClick: () => {
                                set_link_io('input');
                                set_link_pos('');
                            } }, logo_enter)),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.1' },
                            t('Noeud.PF.tooltips.sort'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: (link_io == 'output') ? 'primary' : 'outline-primary', onClick: () => {
                                set_link_io('output');
                                set_link_pos('');
                            } }, logo_exit))))),
        react_1.default.createElement(react_bootstrap_1.Row, { className: 'input_row' },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('Noeud.PF.FRN'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.3' },
                            t('Noeud.PF.tooltips.gauche'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config_node_io', disabled: has_link_come_from(data, display_nodes, multi_selected_nodes, link_io, 'left', GetLinkValue), variant: (link_pos == 'left') ? 'primary' : 'outline-primary', onClick: () => {
                                set_link_pos('left');
                            } }, t('Noeud.PF.gauche'))),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.4', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.4' }, t('Noeud.PF.tooltips.droite')) },
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config_node_io', disabled: has_link_come_from(data, display_nodes, multi_selected_nodes, link_io, 'right', GetLinkValue), variant: (link_pos == 'right') ? 'primary' : 'outline-primary', onClick: () => {
                                set_link_pos('right');
                            } }, t('Noeud.PF.droite'))),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.5', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.5' }, t('Noeud.PF.tooltips.ades')) },
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config_node_io', disabled: has_link_come_from(data, display_nodes, multi_selected_nodes, link_io, 'top', GetLinkValue), variant: (link_pos == 'top') ? 'primary' : 'outline-primary', onClick: () => {
                                set_link_pos('top');
                            } }, t('Noeud.PF.ades'))),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.6', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.6' }, t('Noeud.PF.tooltips.edes')) },
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config_node_io', disabled: has_link_come_from(data, display_nodes, multi_selected_nodes, link_io, 'bottom', GetLinkValue), variant: (link_pos == 'bottom') ? 'primary' : 'outline-primary', onClick: () => {
                                set_link_pos('bottom');
                            } }, t('Noeud.PF.edes')))))),
        react_1.default.createElement(react_bootstrap_1.Row, { className: 'input_row' },
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.pf.tooltips.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.pf.tooltips.7' }, t('Noeud.PF.tooltips.lti')) },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), isChecked: tab_colored, onChange: (evt) => {
                            set_tab_colored(evt.target.checked);
                        } }, t('Noeud.PF.lti'))))),
        tab_pos_link(t, data, display_nodes, multi_selected_nodes, link_pos, link_io, tab_colored, GetLinkValue, link_function, setForceUpdate, forceUpdate)) : react_1.default.createElement(react_1.default.Fragment, null);
    const content_always_present = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { style: { fontSize: '14px', fontWeight: 'bold', textDecoration: 'underline' } }, t('Noeud.Slct')),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { as: react_bootstrap_1.Col },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.8', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.8' },
                        t('Noeud.tooltips.SlctOutLink'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: 'primary', onClick: () => {
                            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                                multi_selected_links.current = multi_selected_links.current.concat(Object.values(data.links).filter(l => d.outputLinksId.includes(l.idLink)));
                                const opacity = (0, SankeyUtils_1.ReturnValueLink)(data, multi_selected_links.current[0], 'opacity');
                                dict_variable_elements_selected.ref_display_link_opacity.current.forEach(setter => setter(opacity));
                            });
                            multi_selected_links.current.forEach(l => (0, SankeyDrawFunction_1.SelectVisualyLinks)(l));
                        } }, t('Noeud.SlctOutLink'))),
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.9', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.9' },
                        t('Noeud.tooltips.SlctInLink'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: 'primary', onClick: () => {
                            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                                multi_selected_links.current = multi_selected_links.current.concat(Object.values(data.links).filter(l => d.inputLinksId.includes(l.idLink)));
                                const opacity = (0, SankeyUtils_1.ReturnValueLink)(data, multi_selected_links.current[0], 'opacity');
                                dict_variable_elements_selected.ref_display_link_opacity.current.forEach(setter => setter(opacity));
                            });
                            multi_selected_links.current.forEach(l => (0, SankeyDrawFunction_1.SelectVisualyLinks)(l));
                        } }, t('Noeud.SlctInLink'))))));
    const content = react_1.default.createElement(react_1.default.Fragment, null,
        content_reorg,
        content_for_one_node,
        content_always_present);
    return menu_for_modal ? content : react_1.default.createElement(react_bootstrap_1.Tab, { key: "node_link_io", className: 'content_editon_elements', eventKey: "node_link_io", title: t('Noeud.PF.PF') }, content);
};
exports.SankeyMenuConfigurationNodesIO = SankeyMenuConfigurationNodesIO;
